package com.eladfinish.bible.contest.data.platform

import kotlinx.browser.window

actual class CountryDetector {
    actual fun getDetectedCountry(): String {
        // navigator.language is typically "he-IL"/"en-US"; the region is the part after the dash.
        return window.navigator.language.substringAfter('-', missingDelimiterValue = "")
    }
}
